import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {Frame, Toast} from '@shopify/polaris';
import {setToastDispatcher} from '../../utils/toast';

export default function ToastProvider({children}) {
  const [toasts, setToasts] = useState([]);
  const idCounterRef = useRef(0);

  const dismissToastById = useCallback(id => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const showToast = useCallback(({content, duration = 3000, error = false}) => {
    idCounterRef.current += 1;
    const id = `${Date.now()}_${idCounterRef.current}`;
    setToasts(prev => [...prev, {id, content, duration, error}]);
    return id;
  }, []);

  useEffect(() => {
    setToastDispatcher(showToast);
    return () => setToastDispatcher(undefined);
  }, [showToast]);

  const renderedToasts = useMemo(
    () =>
      toasts.map(({id, content, duration, error}) => (
        <div key={id} style={{marginTop: 8}}>
          <Toast
            content={content}
            duration={duration}
            error={error}
            onDismiss={() => dismissToastById(id)}
          />
        </div>
      )),
    [toasts, dismissToastById]
  );

  return (
    <>
      {children}
      <div style={{position: 'fixed', top: 12, right: 12, zIndex: 9999}}>
        <Frame>{renderedToasts}</Frame>
      </div>
    </>
  );
}
